// Library imports
import React from 'react';
import { BeatLoader } from 'react-spinners';
import { func, shape, string } from 'prop-types';
import { useTheme } from 'styled-components';
// Styled components
import { SpinnerWrapper } from './styles';

const LoadingSpinner = ({ text = '', onClick = undefined, containerStyle = {} }) => {
    const theme = useTheme();

    return (
        <SpinnerWrapper style={{ ...containerStyle }}>
            <BeatLoader color={theme?.colors?.primary || '#006eb5'} loading={true} />
            {text && <h5 style={{ textAlign: 'center', margin: '15px 0px' }}>{text}</h5>}
            {onClick && (
                <button
                    style={{ marginTop: '10px', padding: '6px 16px', cursor: 'pointer' }}
                    onClick={onClick}
                >
                    Cancel
                </button>
            )}
        </SpinnerWrapper>
    );
};

LoadingSpinner.propTypes = {
    text: string,
    onClick: func,
    containerStyle: shape({}),
};

export default LoadingSpinner;
